const Helpers = {
  stripHtml(html) {
    let tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  },

  getCaretCharacterOffsetWithin: (element) => {
    var caretOffset = 0;
    var doc = element.ownerDocument || element.document;
    var win = doc.defaultView || doc.parentWindow;
    var sel;
    if (typeof win.getSelection != 'undefined') {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
        var range = win.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
      }
    } else if ((sel = doc.selection) && sel.type != 'Control') {
      var textRange = sel.createRange();
      var preCaretTextRange = doc.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint('EndToEnd', textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  },

  getLetterIndex(letters) {
    return letters.split('').reduce((r, a) => r * 26 + parseInt(a, 36) - 9, 0) - 1;
  },

  getAllMergedLabelAndData: (options) => {
    var seriesValues = [];
    options.forEach(function (serie, i) {
      var arr = {},
        extraColumns = [],
        values = [];
      Object.keys(serie).forEach(function (optionKeys) {
        if (optionKeys === 'labels') {
          arr.labelColumn = Helpers.getLetterIndex(options[i][optionKeys]);
        } else if (optionKeys === 'values') {
          const allData = options[i][optionKeys];
          values.push(Helpers.getLetterIndex(allData));
          arr.dataColumns = values;
          arr.dataColumns.sort();
        } else {
          const extraValue = options[i][optionKeys];
          if (extraValue !== '') {
            extraColumns.push(Helpers.getLetterIndex(extraValue));
          }
        }
      });
      arr.extraColumns = extraColumns.sort();
      seriesValues.push(Helpers.merge({}, arr));
    });
    return seriesValues;
  },

  checkSections: (sections, index) => {
    return (sections || []).some(function (section) {
      return (
        (section.dataColumns && section.dataColumns.includes(index)) ||
        (section.extraColumns && section.extraColumns.includes(index)) ||
        section.labelColumn === index
      );
    });
  },

  isTileMap: (options) => {
    return (
      options.options?.series &&
      (options.options.series || []).some(function (s) {
        return s.type === 'tilemap';
      })
    );
  },

  //Used for wordcloud
  convertData: (rows, quoteStrings, section) => {
    var data = [];

    function addData(column, arr) {
      if (quoteStrings && !Helpers.isNum(column) && Helpers.isStr(column)) {
        column = '"' + column.replace(/\"/g, '"') + '"';
      }

      if (Helpers.isNum(column)) {
        column = parseFloat(column);
      }

      arr.push(column);
    }

    rows.forEach(function (row) {
      var rarr = [],
        hasData = false;

      if (section) {
        //Add in label data first
        //addData(row.columns[section[0].labelColumn].value(), rarr);
      }

      row.forEach(function (col, index) {
        if (section && !Helpers.checkSections(section, index)) return;

        var v = col;

        if (v || v === 0) {
          hasData = true;
        }

        addData(v, rarr);
      });

      if (hasData) {
        data.push(rarr);
      }
    });

    return data;
  },

  guessDelimiter: (lines) => {
    var points = 0,
      commas = 0,
      guessed = false;

    const potDelimiters = {
      ',': true,
      ';': true,
      '\t': true,
    };
    const delimiterCounts = {
      ',': 0,
      ';': 0,
      '\t': 0,
    };

    lines.some(function (columnStr, i) {
      var inStr = false,
        c,
        cn,
        cl,
        token = '';
      // We should be able to detect dateformats within 13 rows
      if (i > 10) {
        return true;
      }
      for (var j = 0; j < columnStr.length; j++) {
        c = columnStr[j];
        cn = columnStr[j + 1];
        cl = columnStr[j - 1];
        if (c === '#') {
          // Skip the rest of the line - it's a comment
          return;
        }
        if (c === '"') {
          if (inStr) {
            if (cl !== '"' && cn !== '"') {
              while (cn === ' ' && j < columnStr.length) {
                cn = columnStr[++j];
              }
              // After parsing a string, the next non-blank
              // should be a delimiter if the CSV is properly
              // formed.
              if (typeof potDelimiters[cn] !== 'undefined') {
                potDelimiters[cn]++;
              }
              inStr = false;
            }
          } else {
            inStr = true;
          }
        } else if (typeof potDelimiters[c] !== 'undefined') {
          token = token.trim();
          if (!isNaN(Date.parse(token))) {
            potDelimiters[c]++;
          } else if (isNaN(token) || !isFinite(token) || /^\d+$/.test(token)) {
            potDelimiters[c]++;
          }
          token = '';
        } else {
          token += c;
        }
        if (c === ',') {
          commas++;
        }
        if (c === '.') {
          points++;
        }
      }
    });

    if (potDelimiters[','] > potDelimiters[';'] && potDelimiters[','] > potDelimiters['\t']) {
      guessed = ',';
    } else if (potDelimiters['\t'] >= potDelimiters[';'] && potDelimiters['\t'] >= potDelimiters[',']) {
      guessed = '\t';
    } else {
      guessed = ';';
    }

    return guessed;
  },

  parseCSV: (inData, delimiter, section) => {
    var isStr = Helpers.isStr,
      isArr = Helpers.isArray,
      isNum = Helpers.isNum,
      csv = inData || '',
      result = [],
      options = {
        delimiter: delimiter,
      },
      potentialDelimiters = {
        ',': true,
        ';': true,
        '\t': true,
      },
      delimiterCounts = {
        ',': 0,
        ';': 0,
        '\t': 0,
      };
    //The only thing CSV formats have in common..
    var rows = (csv || '').replace(/\r\n/g, '\n').split('\n');
    // If there's no delimiter, look at the first few rows to guess it.

    if (!options.delimiter) {
      options.delimiter = Helpers.guessDelimiter(rows);
    }

    rows.forEach(function (row, rowNumber) {
      var cols = [],
        inStr = false,
        columnCount,
        i = 0,
        j,
        token = '',
        guessedDel,
        c,
        cp,
        cn;

      function pushToken() {
        columnCount = columnCount + 1 || 0;
        //token = (token || '').replace(/\,/g, '');
        if (!token.length) {
          token = null;
          // return;
        }

        if (isNum(token)) {
          token = parseFloat(token);
        }

        if (section && !Helpers.checkSections(section, columnCount)) {
          token = '';
          return;
        }
        cols.push(token);
        token = '';
      }

      for (i = 0; i < row.length; i++) {
        c = row[i];
        cn = row[i + 1];
        cp = row[i - 1];

        if (c === '"') {
          if (inStr) {
            inStr = false;
            //pushToken();
          } else {
            inStr = true;
          }

          //Everything is allowed inside quotes
        } else if (inStr) {
          token += c;
          //Check if we're done reading a token
        } else if (c === options.delimiter) {
          pushToken();

          //Append to token
        } else {
          token += c;
        }

        // Push if this was the last character
        if (i === row.length - 1) {
          pushToken();
        }
      }

      result.push(cols);
    });
    return result;
  },

  isNull: (what) => {
    return typeof what === 'undefined' || what === null;
  },

  isStr: (what) => {
    return typeof what === 'string' || what instanceof String;
  },

  isNum: (what) => {
    return !isNaN(parseFloat(what)) && isFinite(what);
  },

  isFn: (what) => {
    return (what && typeof what === 'function') || what instanceof Function;
  },

  isArr: (what) => {
    return !Helpers.isNull(what) && what.constructor.toString().indexOf('Array') > -1;
  },

  isBool: (what) => {
    return what === true || what === false;
  },

  isBasic: (what) => {
    return (
      !Helpers.isArr(what) && (Helpers.isStr(what) || Helpers.isNum(what) || Helpers.isBool(what) || Helpers.isFn(what))
    );
  },

  isObj: (what) => {
    return what && what.constructor.toString().indexOf('Object') > -1;
  },

  isEmptyObjectArray: (arr) => {
    return (
      Helpers.isObj(arr[0]) &&
      arr.some((b) => {
        return Object.keys(b).length === 0;
      })
    );
  },

  merge: function (a, b, ignoreEmpty, excludeMap) {
    if (!a || !b) return a || b;

    if (ignoreEmpty && Object.keys(b).length === 0) {
      return;
    }

    Object.keys(b).forEach(function (bk) {
      if (excludeMap && excludeMap[bk]) {
      } else if (Helpers.isNull(b[bk]) || Helpers.isBasic(b[bk])) {
        a[bk] = b[bk];
      } else if (Helpers.isArr(b[bk])) {
        if (Helpers.isEmptyObjectArray(b[bk])) return;
        a[bk] = [];

        b[bk].forEach(function (i) {
          if (Helpers.isNull(i) || Helpers.isBasic(i)) {
            a[bk].push(i);
          } else {
            a[bk].push(Helpers.merge(Helpers.isArr(i) ? [] : {}, i));
          }
        });
      } else if (b[bk].tagName && b[bk].appendChild && b[bk].removeChild && b[bk].style) {
        a[bk] = b[bk];
      } else {
        if (ignoreEmpty && Object.keys(b[bk]).length === 0) {
          return;
        }

        a[bk] = a[bk] || {};
        Helpers.merge(a[bk], b[bk]);
      }
    });
    return a;
  },
};

export default Helpers;
